import { create } from 'zustand';

interface PageBreadcrumbState {
  subLabel: string | null;
  setSubLabel: (label: string | null) => void;
}

export const usePageBreadcrumbStore = create<PageBreadcrumbState>((set) => ({
  subLabel: null,
  setSubLabel: (label) => set({ subLabel: label }),
}));
